<template id="village-page">
  <slot
    name="content"
    :showInfoPackForm="showInfoPackForm"
    :openFullGalleryView="openFullGalleryView"
    :sliderIndexClass="sliderIndexClass"
    :controls="controls"
    :galleryIndex="galleryIndex"
    :index="index"
    :toggleShareForm="toggleShareForm"
    :showRequestButtonStickyFooter="showRequestButtonStickyFooter"
    :showMoreOpenDays="showMoreOpenDays"
    :showMoreEvents="showMoreEvents"
    :isReadMore="isReadMore"
    :triggerReadMore="triggerReadMore"
    :showTour="showTour"
    :showManagerNumberButton="showManagerNumberButton"
    :showManagerNumberId="showManagerNumberId"
    :enquiryAttachment="enquiryAttachment"
    :clickTile="clickTile"
    :showPropertyListModal="showPropertyListModal"
    :propertyInfoId="propertyInfoId"
    :globalStore="globalStore"
    :showEventRegisterForm="showEventRegisterForm"
    :saveRemoveFavourite="saveRemoveFavourite"
    :selectedTypeId="selectedTypeId"
    :toggleTypeOfHome="toggleTypeOfHome"
    :closeLightBox="closeLightBox"
    :showCareHomeForm="showCareHomeForm"
    :isCompareChecked="isCompareChecked"
    :addRemoveToCompareList="addRemoveToCompareList"
    :compareNowRedirect="compareNowRedirect"
    :toggleModal="toggleModal"
    :isMobile="isMobile"
    :toggleOpenDays="toggleOpenDays"
    :toggleEvents="toggleEvents"
    :showAllProperties="showAllProperties"
    :toggleProperties="toggleProperties"
    :tileClick="tileClick"
  ></slot>
</template>
<script setup>
import {computed, nextTick, onBeforeMount, onMounted, ref} from 'vue'
import {useCommon} from '../../composables/useCommon'
import {useFormSubmit} from '../../composables/useFormSubmit'
import useCompareStore from '../../store/compareStore'
import useGlobalStore from '../../store/globalStore'
import cookieHelper from '../cookie'
import {useRestHomeCompare} from '../../composables/useRestHomeCompare'

const index = ref(null)
const { openFullGalleryView, triggerReadMore, showTour, showManagerNumberButton, showManagerNumberId, closeLightBox, isReadMore, productImpression } = useCommon(index)
const { showPropertyListModal, showEventRegisterForm, toggleModal, clickTile, pushTileClickData } = useFormSubmit()
const { showCareHomeForm, isCompareChecked, addRemoveToCompareList } = useRestHomeCompare()
const compareStore = useCompareStore()
const globalStore = useGlobalStore()

// Define props
const props = defineProps({
  villageUrl: {
    type: String,
    default: '',
  },
  showInfoPack: {
    type: Boolean,
    default: false,
  },
  villageId: {
    type: String,
    default: '',
  },
  villageName: {
    type: String,
    default: '',
  },
  dataLayerProperties: {
    type: Object,
    default: () => [],
  },
  defaultTypeOfHomeId: {
    type: Number,
    default: 0,
  },
})

const showTypeOfHomeFullViewId = ref(false);
const maxCharsReadMore = ref(400);
const requestButtonOffSet = ref(0);
const showRequestButtonStickyFooter = ref(false);
const propertyInfoId = ref(false);
const controls = ref([
  '<i class=\'icon icon--arrow-left\'></i>',
  '<i class=\'icon icon--arrow-right\'></i>'
]);

const indexTypeOfHomes = ref(null)

const subjectRadio = ref('Request an information pack')
const showMoreOpenDays = ref(false)
const showMoreEvents = ref(false)
const isMobile = ref(false)
const showAllProperties = ref(false)

const galleryIndex = ref(1)
const requestInformationButton = ref(null)
const selectedTypeId = ref(props.defaultTypeOfHomeId)

// Computed properties
const sliderIndexClass = computed(() => `slider-index-${galleryIndex.value}`)

// Methods
const toggleShareForm = (title, type, id) => {
  globalStore.setModal(
    {
      name: 'villageShareModal',
      id: id,
      title: title,
      customField: type,
    }
  )
}

const toggleOpenDays = () => {
  showMoreOpenDays.value = !showMoreOpenDays.value
}

const toggleEvents = () => {
  showMoreEvents.value = !showMoreEvents.value
}

const enquiryAttachment = (title, id, villageId, type, event) => {
  let villageAttachment = cookieHelper.getCookie(`${type}Attachment${villageId}`);

  if (!villageAttachment) {
    globalStore.setModal(
      {
        name: 'villageEnquiryAttachmentModal',
        title: `Download <br><span>${title}</span>`,
        id: id,
        customField: title,
      }
    )
    event.preventDefault();
    return false;
  }

  return true;
}

const openTypeOfHoneFulView = (id, index) => {
  showTypeOfHomeFullViewId.value = id;
  indexTypeOfHomes.value = index;
}

const handleScroll = (event) => {
  if (!window.matchMedia('screen and (min-width: 1200px)').matches) {
    showRequestButtonStickyFooter.value = (window.pageYOffset > requestButtonOffSet.value);
  }
}

const getElementOffset = (el) => {
  let top = 0;
  let element = el;
  if (element === undefined || element === null) {
    return top;
  }

  // Loop through the DOM tree
  // and add it's parent's offset to get page offset
  do {
    top += element.offsetTop || 0;
    element = element.parentElement;
  } while (element);

  return top;
}

const tileClick = (id, e) => {
  const ele = e.target.closest(`#tile_${id}`);
  pushTileClickData(ele);
};

const showInfoPackForm = async (villageId, villageName, action, e) => {
  const modelName = action === 'email-village' ? 'emailEnquiryModal' : 'villageInfoPackModal';
  globalStore.setModal(
    {
      name: modelName,
      id: villageId,
      customField: action,
      title: villageName,
      descriptionPlaceholder: `Please send me an information pack for ${villageName}`,
    }
  )

  if (action !== 'email-village') {
    let currentUrl = window.location.href;
    currentUrl = currentUrl.replace('/info-pack', ''); // remove /info-pack if exists
    history.pushState(null, null, `${currentUrl}/info-pack`);
    await nextTick()

    const ele = e.target;
    const form = document.getElementById('village-enquiry-form');
    form.querySelector('#property_name').value = villageName;
    form.querySelector('#operator_name').value = ele.dataset.operatorName;
    form.querySelector('#operator_id').value = ele.dataset.operatorId;
    form.querySelector('#enquiry_type_full').value = ele.dataset.enquiryTypeFull;
    form.querySelector('#subscription').value = ele.dataset.subscription;
    form.querySelector('#enquiry_region').value = ele.dataset.enquiryRegion;
    form.querySelector('#enquiry_district').value = ele.dataset.enquiryDistrict;
    form.querySelector('#enquiry_district').value = ele.dataset.enquiryDistrict;

    if (ele.dataset.abTest === 'yes') {
      form.querySelector('#is_ab_testing_modal').value = 'yes';
    }
  }
}

const showManagerNumber = (e) => {
  e.target.style.opacity = 0;
  e.target.parentElement.querySelector('span').style.opacity = '1';
  e.target.parentElement.querySelector('span').style.zIndex = '3';
}

const toggleTypeOfHome = (id) => {
  selectedTypeId.value = id;
}

// const ageConcernSubmit = (e) => {
//   this.$validator.validateAll().then((result) => {
//     if (result) {
//       const buttons = e.target.getElementsByClassName('submit');
//       for (let i = 0; i < buttons.length; i++) {
//         buttons[i].disabled = true;
//       }
//       const msgBox = this.$refs.messageBox;
//       let formData = new FormData(e.target);
//       msgBox.classList.add('message--warning');
//       msgBox.classList.add('mt-4');
//       msgBox.innerHTML = 'Submitting....';
//       msgBox.style.display = 'block';
//       msgBox.style.opacity = 1;
//       msgBox.style.height = 'auto';
//
//       axios.post(e.target.action, formData).then(function (response) {
//         const msg = response.data.msg;
//         msgBox.style.display = 'block';
//         msgBox.classList.remove('message--danger', 'message--warning');
//         msgBox.classList.add('message--success');
//
//         // Reset the form
//         e.target.reset();
//
//         msgBox.innerHTML = msg;
//
//         for (let i = 0; i < buttons.length; i++) {
//           buttons[i].disabled = false;
//         }
//       });
//     }
//   });
// }

const compareNowRedirect = () => {
  const result = compareStore.careHomeCompareList.map(function (list) {
    return list.id;
  }).join(',')

  window.location.href = `/rest-homes-compare?compareList=${result}`
}

const sliderIndexChanged = (e) => {
  galleryIndex.value = e.displayIndex;
}

const toggleProperties = () => {
  showAllProperties.value = !showAllProperties.value
}

onBeforeMount(async () => {
  window.addEventListener('scroll', handleScroll);
  await nextTick()
  if (window.matchMedia('screen and (min-width: 1200px)').matches) {
    // if (requestInformationButton !== undefined) {
    //   console.log(requestInformationButton)
    //   requestButtonOffSet.value = requestInformationButton.getBoundingClientRect().top - 125;
    // }
  } else {
    //this.requestButtonOffSet = this.getElementOffset(this.$refs.requestInformationButton);
    //this.requestButtonOffSet = 500;
  }

  // Update the google tag manager event.
  window.dataLayer = window.dataLayer || [];
  const dataLayerValues = document.getElementById('dataLayerValues');

  if (dataLayerValues !== null) {
    dataLayer.push({ecommerce: null});
    dataLayer.push(JSON.parse(dataLayerValues.value));
  }

  if (props.showInfoPack) {
    globalStore.setModal(
      {
        name: 'villageInfoPackModal',
        id: props.villageId,
        title: props.villageName,
        customField: props.villageUrl,
        setModalDescriptionPlaceholder: `Please send me an information pack for ${props.villageName}`,
      }
    )
  }

  let currentUrl = window.location.href;

  if (currentUrl.includes('#care-suites') ||
    currentUrl.includes('#standard-rooms') ||
    currentUrl.includes('#premium-rooms') ||
    currentUrl.includes('#serviced-apartments')
  ) {
    let hashValue = currentUrl.split('#')[1];
    hashValue = hashValue.replace('-', '_');
    hashValue = hashValue.charAt(0).toUpperCase() + hashValue.slice(1)

    if (document.getElementById(`${hashValue}_toggle_button`) !== null ||
      document.getElementById(`${hashValue}_button`) !== null
    ) {
      if (document.getElementById(`${hashValue}_toggle_button`) !== null) {
        document.getElementById(`${hashValue}_toggle_button`).click();
      }

      setTimeout(function () {
        document.getElementById(`${hashValue}_button`).click();
      }, 1000);
    }
  }

  if (currentUrl.includes('#room-availability')) {
    document.getElementById('check-room-availability').click();
  }

  if (currentUrl.includes('#homes-for-sale')) {
    document.getElementById('village-hfs-link').click();
  } else if (currentUrl.includes('#homes')) {
    document.getElementById('village-type-of-homes-link').click();
  }

  if (currentUrl.includes('#accomodation')) {
    document.getElementById('village-types-of-rooms-link').click();
  }

  if (currentUrl.includes('#email')) {
    document.getElementById('village-email-form').click();
  }

  const element = window.location.hash.substring(1);

  if (element.startsWith('learn-more')) {
    // get the id(123) from element, element is like learn-more-123
    const eventId = element.split('-')[2];
    // click the id like event-123
    document.getElementById(`event-${eventId}`).click();
  }

  if (window.innerWidth <= 991 ) {
    isMobile.value = true
  }
})

onMounted(() => {
  if (props.dataLayerProperties.items.length > 0) {
    productImpression(props.dataLayerProperties);
  }
})


//
//
// export default {
//
//   // mixins: [villageCareHome, mapMixin, commonMixin, addressFieldMixin, formSubmit],
//
//   methods: {
//     toggleShareForm(title, type, id) {
//       //this.$store.commit('setShowModalFooter');
//       this.$store.commit('setModal', 'villageShareModal');
//       this.$store.commit('setModalTitle', title);
//       this.$store.commit('setModalCustomField', type);
//       this.$store.commit('setModalId', id);
//
//       setTimeout(function() {
//         let $wire = Livewire.find('shareForm');
//         $wire.type = type;
//         $wire.typeId = id;
//       }, 2000);
//     },
//
//     enquiryAttachment(title, id, villageId, type, event) {
//       // let villageAttachment = cookieHelper.getCookie(`${type}Attachment${villageId}`);
//       //
//       // if (!villageAttachment) {
//       //   this.$store.commit('setModal', 'villageEnquiryAttachmentModal');
//       //   this.$store.commit('setModalId', id);
//       //   this.$store.commit('setModalCustomField', title);
//       //   this.$store.commit('setModalTitle', `Download <br><span>${title}</span>`);
//       //
//       //   event.preventDefault();
//       //   return false;
//       // }
//       //
//       // return true;
//     },
//
//     /**
//      * Open full gallery view for village type of home.
//      * @param {int} id
//      * @param {int} index
//      */
//     openTypeOfHoneFulView(id, index) {
//       this.showTypeOfHomeFullViewId = id;
//       this.indexTypeOfHomes = index;
//     },
//
//     handleScroll(event) {
//       if (!window.matchMedia('screen and (min-width: 1200px)').matches) {
//         this.showRequestButtonStickyFooter = (window.pageYOffset > this.requestButtonOffSet);
//       }
//     },
//     getElementOffset(el) {
//       let top = 0;
//       let element = el;
//       if (element === undefined || element === null) {
//         return top;
//       }
//
//       // Loop through the DOM tree
//       // and add it's parent's offset to get page offset
//       do {
//         top += element.offsetTop || 0;
//         element = element.parentElement;
//       } while (element);
//
//       return top;
//     },
//
//
//     validateBeforeSubmit(scope = '', e) {
//       const store = this.$store;
//       const vue = this;
//       this.$validator.validateAll(scope).then((result) => {
//         if (result) {
//           const buttons = e.target.getElementsByClassName('submit');
//           for (let i = 0; i < buttons.length; i++) {
//             buttons[i].disabled = true;
//           }
//           const msgBox = e.target.getElementsByClassName('message')[0];
//           let formData = new FormData(e.target);
//           msgBox.classList.add('message--warning');
//           msgBox.innerHTML = 'Submitting....';
//           msgBox.style.display = 'block';
//           msgBox.style.opacity = 1;
//           msgBox.style.height = 'auto';
//
//           if (e.target.dataset.formtype === 'enquiry' && cookieHelper.getCookie('villageInfoSuccess') !== null) {
//             formData.append('successInfo', cookieHelper.getCookie('villageInfoSuccessInfo'));
//           }
//
//           window.grecaptcha.execute(this.$parent.mySiteKeyVariable, {
//             action: formData.get('captcha_action'),
//           }).then((token) => {
//             formData.set('g-recaptcha-response', token);
//             axios.post(e.target.action, formData).then(function (response) {
//               const msg = response.data.msg;
//               msgBox.style.display = 'block';
//               msgBox.classList.remove('message--danger', 'message--warning');
//               msgBox.classList.add('message--success');
//
//               // Reset the form
//               e.target.reset();
//
//               msgBox.innerHTML = msg;
//
//               if (e.target.dataset.formLocation === 'contactList') {
//                 vue.showEnquirySuccess = true;
//               }
//
//               if (e.target.dataset.formtype === 'enquiry') {
//                 history.pushState(null, null, `${vue.villageUrl}#enquiry-submitted`);
//
//                 vue.enquirySubmitDataLayer(response, e.target);
//
//                 if (e.target.dataset.formtype === 'enquiry' && cookieHelper.getCookie('villageInfoSuccess') === null) {
//                   store.commit('setModal', 'villageInfoPackSuccessModal');
//                   store.commit('setModalTitle', vue.villageName);
//                   cookieHelper.setCookie('villageInfoSuccess', 'true', 365);
//                 }
//
//                 vue.sendFBLeadData(formData.get('subject'));
//               }
//
//               if (e.target.dataset.formtype === 'enquirySuccess') {
//                 const successData = JSON.stringify(
//                   {
//                     interested: formData.get('interested'),
//                     lookingMove: formData.get('looking-move'),
//                     myAge: formData.get('my-age'),
//                     myPartnerAge: formData.get('my-partner-age'),
//                   }
//                 );
//                 cookieHelper.setCookie('villageInfoSuccessInfo', successData, 365);
//               }
//
//               setTimeout(function () {
//                 msgBox.style.opacity = '0';
//                 msgBox.style.height = '0';
//
//                 if (store.getters.getModal === 'villageInfoPackModal' ||
//                   store.getters.getModal === 'villageShareModal' ||
//                   store.getters.getModal === 'careHomeFormModal' ||
//                   e.target.dataset.formtype === 'enquirySuccess') {
//                   store.commit('setModal', false);
//                   store.commit('setModalId', false);
//                   document.querySelector('body').classList.remove('modal-open', 'stop-scrolling');
//                 }
//               }, 4000);
//
//             }).catch(error => {
//               if (error.response) {
//                 for (let i = 0; i < buttons.length; i++) {
//                   buttons[i].disabled = false;
//                 }
//
//                 const errors = error.response.data.errors;
//                 for (let i in errors) {
//                   msgBox.innerHTML = errors[i];
//                 }
//                 msgBox.style.display = 'block';
//                 msgBox.classList.remove('message--success');
//                 msgBox.classList.remove('message--warning');
//                 msgBox.classList.add('message--danger');
//               }
//             });
//           });
//
//           return false;
//         }
//         this.$scrollTo(document.getElementsByClassName('is-danger')[0], 500, {offset: -160});
//       });
//     },
//
    const saveRemoveFavourite = (event, type, type_id, isAuth) => {
      // if (isAuth === false) {
      //   this.$store.commit('setShowModalFooter', true);
      //   this.$store.commit('setModal', 'loginModal');
      //   return;
      // }
      // let text = '';
      // const store = this.$store;
      // const awn = this.$awn;
      //
      // axios.post('/save-remove-item', {
      //   type: type,
      //   type_id: type_id,
      //   _token: document.head.querySelector('[name~=csrf-token][content]').content,
      // }).then(function (response) {
      //   const added = response.data.added;
      //   let tarEl = event.target;
      //
      //   if (event.target.tagName === 'A') {
      //     tarEl = event.target.querySelector('i');
      //   }
      //
      //   if (added === true) {
      //     text = 'Saved to your list';
      //     tarEl.classList.add('icon--heart-selected');
      //   } else {
      //     text = 'Removed from your list';
      //     tarEl.classList.remove('icon--heart-selected');
      //   }
      //
      //   if (window.matchMedia('screen and (max-width: 768px)').matches) {
      //     awn.success(text);
      //     return;
      //   }
      //
      //   store.commit('setShowModalFooter', false);
      //   if (response.data.showInitialModal) {
      //     store.commit('setModal', 'successFavouriteInitialModal');
      //   } else {
      //     store.commit('setModal', 'successFavouriteModal');
      //     //
      //     // setTimeout(function() {
      //     //   store.commit('setModal', false);
      //     //   store.commit('setModalId', false);
      //     //   document.querySelector('body').classList.remove('modal-open', 'stop-scrolling');
      //     // }, 1500);
      //   }
      //   store.commit('setModalTitle', text);
      // }).catch(error => {
      //   if (error.response) {
      //     //
      //   }
      // });
    }
//
//     showInfoPackForm(villageId, villageName, action, e) {
//       console.log(villageName);
//       this.$store.commit('setModalId', villageId);
//       this.$store.commit('setModalTitle', villageName);
//       this.$store.commit('setModalDescriptionPlaceholder', `Please send me an information pack for ${villageName}`);
//       this.$store.commit('setModalCustomField', action);
//
//       if (action === 'email-village') {
//         this.$store.commit('setModal', 'emailEnquiryModal');
//       } else {
//         this.$store.commit('setModal', 'villageInfoPackModal');
//
//         let currentUrl = window.location.href;
//         currentUrl = currentUrl.replace('/info-pack', ''); // remove /info-pack if exists
//         history.pushState(null, null, `${currentUrl}/info-pack`);
//
//         this.$nextTick(() => {
//           const ele = e.target;
//           const form = document.getElementById('village-enquiry-form');
//           form.querySelector('#property_name').value = villageName;
//           form.querySelector('#operator_name').value = ele.dataset.operatorName;
//           form.querySelector('#operator_id').value = ele.dataset.operatorId;
//           form.querySelector('#enquiry_type_full').value = ele.dataset.enquiryTypeFull;
//           form.querySelector('#subscription').value = ele.dataset.subscription;
//           form.querySelector('#enquiry_region').value = ele.dataset.enquiryRegion;
//           form.querySelector('#enquiry_district').value = ele.dataset.enquiryDistrict;
//           form.querySelector('#enquiry_district').value = ele.dataset.enquiryDistrict;
//
//           if (ele.dataset.abTest === 'yes') {
//             form.querySelector('#is_ab_testing_modal').value = 'yes';
//           }
//         });
//       }
//     },
//
//     showManagerNumber(e) {
//       e.target.style.opacity = 0;
//       e.target.parentElement.querySelector('span').style.opacity = '1';
//       e.target.parentElement.querySelector('span').style.zIndex = '3';
//     },
//
//     ageConcernSubmit(e) {
//       this.$validator.validateAll().then((result) => {
//         if (result) {
//           const buttons = e.target.getElementsByClassName('submit');
//           for (let i = 0; i < buttons.length; i++) {
//             buttons[i].disabled = true;
//           }
//           const msgBox = this.$refs.messageBox;
//           let formData = new FormData(e.target);
//           msgBox.classList.add('message--warning');
//           msgBox.classList.add('mt-4');
//           msgBox.innerHTML = 'Submitting....';
//           msgBox.style.display = 'block';
//           msgBox.style.opacity = 1;
//           msgBox.style.height = 'auto';
//
//           axios.post(e.target.action, formData).then(function (response) {
//             const msg = response.data.msg;
//             msgBox.style.display = 'block';
//             msgBox.classList.remove('message--danger', 'message--warning');
//             msgBox.classList.add('message--success');
//
//             // Reset the form
//             e.target.reset();
//
//             msgBox.innerHTML = msg;
//
//             for (let i = 0; i < buttons.length; i++) {
//               buttons[i].disabled = false;
//             }
//           });
//         }
//       });
//     },
//     compareNowRedirect() {
//       const result = this.$store.getters.getCareHomeCompareList.map(function (list) {
//         return list.id;
//       }).join(',');
//       window.location.href = `/rest-homes-compare?compareList=${result}`;
//     },
//
//     sliderIndexChanged(e) {
//       this.galleryIndex = e.displayIndex;
//     },
//
//   },
//   computed: {
//     sliderIndexClass() {
//       return `slider-index-${this.galleryIndex}`
//     },
//   },
//   created() {
//     this.$nextTick(() => {
//
//
//
//     });
//
//     window.addEventListener('scroll', this.handleScroll);
//   },
//   mounted() {
//     if (this.$refs.villageSlider) {
//       this.$refs.villageSlider.slider.events.on('indexChanged', this.sliderIndexChanged);
//     }
//
//     if (this.dataLayerProperties.items.length > 0) {
//       this.productImpression(this.dataLayerProperties);
//     }
//   }
// };
</script>
